var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex header-wrapper"},[_c('div',{staticClass:"sku-table-title mr-1"},[_vm._v(" "+_vm._s(_vm.$l('title_sku_table_info') || '备货产品明细')+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }